"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePreview = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
var modal_1 = require("../modal");
var justify_1 = require("../justify");
var button_1 = require("../button");
var i18n_1 = require("../i18n");
var util_1 = require("../util");
var inject_value_1 = require("../_util/inject-value");
/**
 * 图片预览
 */
exports.ImagePreview = react_1.default.forwardRef(function ImagePreview(props, ref) {
    var t = i18n_1.useTranslation();
    var classPrefix = config_context_1.useConfig().classPrefix;
    var previewSrc = props.previewSrc, className = props.className, previewTitle = props.previewTitle, src = props.src, children = props.children, maskClosable = props.maskClosable, restProps = tslib_1.__rest(props, ["previewSrc", "className", "previewTitle", "src", "children", "maskClosable"]);
    var _a = tslib_1.__read(react_1.useState(false), 2), visible = _a[0], setVisible = _a[1];
    var child = react_1.useMemo(function () {
        if (src) {
            return (react_1.default.createElement("img", tslib_1.__assign({ ref: ref, alt: "preview", src: src, className: classnames_1.default(className, classPrefix + "-img__preview"), title: t.clickToEnlarge }, restProps, { onClick: util_1.callBoth(function () { return setVisible(true); }, restProps.onClick) })));
        }
        return inject_value_1.injectValue(children)(function () {
            setVisible(true);
        });
    }, [children, className, classPrefix, ref, restProps, src, t.clickToEnlarge]);
    var content = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classPrefix + "-dialog__header" },
            react_1.default.createElement(justify_1.Justify, { left: react_1.default.createElement("h3", { className: classPrefix + "-dialog__headertitle" }, previewTitle), right: react_1.default.createElement(button_1.Button, { type: "icon", icon: "close", htmlType: "button", onClick: function () { return setVisible(false); }, "aria-label": t.closeText }) })),
        react_1.default.createElement(modal_1.Modal.Body, null,
            react_1.default.createElement("img", { src: previewSrc, alt: "", onClick: function (e) { return e.stopPropagation(); } }))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        child,
        react_1.default.createElement(modal_1.Modal, { disableCloseIcon: true, className: classPrefix + "-dialog--img", visible: visible, onClose: function () { return setVisible(false); }, onExited: function () { return setVisible(false); } }, maskClosable ? (react_1.default.createElement("div", { style: { height: "100%", width: "100%" }, onClick: function () { return setVisible(false); } }, content)) : (content))));
});
exports.ImagePreview.displayName = "ImagePreview";
//# sourceMappingURL=ImagePreview.js.map